// Hold the species needed for the patient forms
export const Species = [
  "Avian", 
  "Canine", 
  "Feline", 
  "Reptile",
  "Rodent"
];